import StarRating from "vue-star-rating";
import { request } from "@/js/http/http_request";
export default {
  name: "rating",
  data: function data() {
    return {
      rating: 0,
      activeColor: "",
      defaultColor: "#ffd055",
      userRatingColor: "#ffd055",
      nbRating: 0,
      userRating: null,
      isRatingInProgress: false
    };
  },
  components: {
    StarRating: StarRating
  },
  props: ["idWine", "listRatings"],
  created: function created() {
    var _this = this;
    request("/v1/rating/" + _this.idWine, "get", null, true, "api").then(function (response) {
      if (response.data.average_rating != null) {
        _this.rating = response.data.average_rating;
        _this.activeColor = _this.defaultColor;
        _this.nbRating = response.data.nb_rating;
        _this.userRating = response.data.user_rating;
      } else {
        _this.activeColor = _this.defaultColor;
      }
    });
  },
  methods: {
    rate: function rate(event) {
      if (!this.isRatingInProgress) {
        this.isRatingInProgress = true;
        this.rating = event;
        this.activeColor = this.userRatingColor;
        var _this = this;
        var verb = this.userRating == event ? "delete" : this.userRating ? "put" : "post";
        request("/v1/rating/" + _this.idWine, verb, {
          rating: _this.rating
        }, true, "api").then(function () {
          if (verb == "post") {
            _this.$toasted.show("Rating saved.", {
              type: "success"
            });
          } else if (verb == "put") {
            _this.$toasted.show("Rating updated.", {
              type: "success"
            });
          } else {
            _this.$toasted.show("Rating deleted.", {
              type: "success"
            });
          }
          request("/v1/rating/" + _this.idWine, "get", null, true, "api").then(function (response) {
            if (response.data.average_rating != null) {
              _this.rating = response.data.average_rating;
              _this.activeColor = response.defaultColor;
              _this.nbRating = response.data.nb_rating;
              _this.userRating = response.data.user_rating;
            } else {
              _this.rating = null;
              _this.activeColor = _this.defaultColor;
              _this.nbRating = 0;
              _this.userRating = null;
            }
            _this.isRatingInProgress = false;
          });
        });
      }
    }
  }
};